import { Button } from "@sirdab/ui";

import { useMessages } from "../i18n";

export interface StepActionsProps {
  onBack?: (() => void) | undefined;
  onNext?: (() => void) | undefined;
  /** Already-localised. Defaults to `action.continue`. */
  nextLabel?: string | undefined;
  nextDisabled?: boolean | undefined;
  nextLoading?: boolean | undefined;
  nextType?: "button" | "submit" | undefined;
}

/**
 * The forward/back pair every step ends with. Order is source order — `flex-col` on a
 * phone, so nothing here depends on a physical side and Arabic needs no override. The
 * forward action is THE action of the view (primary, touch height, full width); back is a
 * ghost so it never competes.
 */
export function StepActions({
  onBack,
  onNext,
  nextLabel,
  nextDisabled = false,
  nextLoading = false,
  nextType = "button",
}: StepActionsProps): React.JSX.Element {
  const { t } = useMessages();
  return (
    <div className="flex flex-col gap-2 pt-2">
      {onNext !== undefined || nextType === "submit" ? (
        <Button
          type={nextType}
          size="touch"
          disabled={nextDisabled}
          loading={nextLoading}
          className="w-full"
          {...(onNext === undefined ? {} : { onClick: onNext })}
        >
          {nextLabel ?? t("action.continue")}
        </Button>
      ) : null}
      {onBack !== undefined ? (
        <Button
          type="button"
          variant="ghost"
          size="touch"
          onClick={onBack}
          className="w-full"
        >
          {t("action.back")}
        </Button>
      ) : null}
    </div>
  );
}
